<header>
  <h1 mat-dialog-title class="truncate">
    @if (data.titleIcon) {
      <mat-icon [fontIcon]="data.titleIcon"></mat-icon>
    }
    {{ data.title }}
  </h1>
</header>
<div mat-dialog-content class="grid-2">
  @if (data.message) {
    <h2>{{ data.message }}</h2>
  }
</div>
<section mat-dialog-actions class="footer-btns" [ngClass]="data.alternativeText ? 'three-buttons' : ''">
  <button mat-button theme-style="nav" appRipple [mat-dialog-close]="false" tabindex="0">
    {{ data.negativeText }}
  </button>
  <button mat-button theme-style="nav" appRipple [mat-dialog-close]="true">
    {{ data.positiveText }}
  </button>
  @if (data.alternativeText) {
    <button mat-button theme-style="nav" appRipple [mat-dialog-close]="data.alternativeText">
      {{ data.alternativeText }}
    </button>
  }
</section>
